module.exports = __webpack_public_path__ + "img/speed-module.300c4d99.png";